export default {
    methods: {
        changePhoneInput(event) {
            let phone = event.target.value
                .replace('(', '')
                .replace(')', '')
                .replace('-', '')
                .replace(' ', '');

            if (phone !== this.form.phone) {
                this.form.phone = phone;
            }
        },

        getOnlyDDDOfPhone(phone) {
            if (phone) {
                phone = this.clearPhone(phone);

                return phone.substring(0, 2);
            }

            return null;
        },

        getOnlyNumberPhone(phone) {
            if (phone) {
                phone = this.clearPhone(phone);

                return phone.substring(2, phone.length);
            }
        },

        clearPhone(phone) {
            return phone
                .replace('(', '')
                .replace(')', '')
                .replace('-', '')
                .replace(' ', '')
        }
    }
}
